enum NODE_TYPES {
  START_NODE = 'START_NODE',
  IVR_NODE_DIAL = 'IVR_NODE_DIAL',
  IVR_NODE_FORWARD = 'IVR_NODE_FORWARD',
  IVR_NODE_HTTP = 'IVR_NODE_HTTP',
  IVR_NODE_HTTP2 = 'IVR_NODE_HTTP2',
  IVR_NODE_INPUT = 'IVR_NODE_INPUT',
  IVR_NODE_MENU = 'IVR_NODE_MENU',
  IVR_NODE_MESSAGE = 'IVR_NODE_MESSAGE',
  IVR_NODE_NUMBER_MATCH = 'IVR_NODE_NUMBER_MATCH',
  IVR_NODE_SCHEDULE = 'IVR_NODE_SCHEDULE',
  IVR_NODE_SMS = 'IVR_NODE_SMS',
  IVR_NODE_VARIABLE = 'IVR_NODE_VARIABLE',
  IVR_NODE_VARIABLE_MATCH = 'IVR_NODE_VARIABLE_MATCH',
  IVR_NODE_VOICEMAIL = 'IVR_NODE_VOICEMAIL',
  IVR_NODE_SCHEDULE_TEMPORARY_SPLIT = 'TEMPORARY_SPLIT',
  IVR_NODE_EMAIL_AUTH_CODE = 'IVR_NODE_EMAIL_AUTH_CODE',
  IVR_NODE_EXTERNAL_DATA = 'IVR_NODE_EXTERNAL_DATA',
  IVR_NODE_DATA_DISPLAY = 'IVR_NODE_DATA_DISPLAY',
  IVR_NODE_VERIFY_AUTH_CODE = 'IVR_NODE_VERIFY_AUTH_CODE',
  IVR_NODE_VOICE_AUTOMATION = 'IVR_NODE_VOICE_AUTOMATION',
  IVR_NODE_HANDOFF = 'IVR_NODE_HANDOFF',
}

export default NODE_TYPES;
